import { useEffect, useRef, useState } from "react";

// import DocTabs from "../../../DocPage/new-doc-page/components/docTabs";
import PageFilters from "../../../DocPage/new-doc-page/components/pageFilters";
import TabsComponentNotesLevel from "../../../TreatmentPage/TabsComponentNotesLevel";

const ResponsiveTabPhotoContainer = ({
  onSelect,
  data,
  allCount,
  unsortedCount,
  activeTab,
  tabsData,
  _photoTab,
  currentPage,
}) => {
  const containerRef = useRef(null);
  const specialtyRef = useRef(null);
  const viewRef = useRef(null);
  //   const photoRef = useRef(null);
  const [hasInitialized, setHasInitialized] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const measureAndSetBreakpoints = () => {
      if (!containerRef.current || !specialtyRef.current || !viewRef.current || hasInitialized) {
        return;
      }

      // Get actual widths
      const specialtyWidth = specialtyRef.current.offsetWidth;
      const viewWidth = viewRef.current.offsetWidth;
      const minGap = 15;
      const photosRightMargin = 200;

      // Calculate breakpoints based on maintaining 15px gaps
      const largeBreakpoint =
        specialtyWidth + minGap + viewWidth + minGap + 112 + photosRightMargin;

      const mediumBreakpoint = specialtyWidth + minGap + 250 + minGap + 66 + photosRightMargin;

      const updateResponsiveClass = () => {
        if (!containerRef.current) return;

        const containerWidth = containerRef.current.offsetWidth;
        const container = containerRef.current;
        container.classList.remove("responsive-large", "responsive-medium", "responsive-small");

        if (containerWidth >= largeBreakpoint) {
          container.classList.add("responsive-large");
          setIsCollapsed(false);
        } else if (containerWidth >= mediumBreakpoint) {
          container.classList.add("responsive-medium");
          setIsCollapsed(false);
        } else {
          container.classList.add("responsive-small");
          setIsCollapsed(true);
        }
      };

      updateResponsiveClass();

      const resizeObserver = new ResizeObserver(() => {
        updateResponsiveClass();
      });

      resizeObserver.observe(containerRef.current);
      setHasInitialized(true);

      return () => resizeObserver.disconnect();
    };

    const timeoutId = setTimeout(measureAndSetBreakpoints, 100);
    return () => clearTimeout(timeoutId);
  }, [data.length, hasInitialized]);

  useEffect(() => {
    setHasInitialized(false);
  }, [data.length]);
  return (
    <div
      ref={containerRef}
      className="smart-responsive-tabs-wrapper"
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "25px",
        position: "relative",
        gap: "15px",
        justifyContent: "space-between",
      }}
    >
      <div ref={specialtyRef} className="specialty-section">
        <PageFilters
          specialitiesList={data}
          activeSpecialty={activeTab}
          onSelect={onSelect}
          allCount={allCount}
          isCollapsed={isCollapsed}
        />
      </div>

      <div ref={viewRef} className="view-tabs-section">
        <TabsComponentNotesLevel handlePage={currentPage} tabsData={tabsData} height={25} />
        {/* <DocTabs labelClass="ps-2 pe-2" handlePage={currentPage} tabsData={tabsData} height={25} /> */}
      </div>

      <div className="">
        <nav className="notes-nav-tab pe-0">
          <div
            className="nav nav-tabs d-flex-lg-1  ps-2 justify-content-end"
            id="nav-tab-account-checks"
            role="tablist"
          >
            <a
              className={`nav-item nav-link nav-responsive ${activeTab === "unsorted" ? "active" : ""} show rlmargin-z note-categories-spaces`}
              id="custom-nav-all-tab"
              href="#custom-nav-all"
              role="tab"
              aria-controls="custom-nav-all"
              aria-selected="true"
              onClick={() => onSelect("unsorted", "Unsorted")}
            >
              Unsorted <span className="m-l-5">{unsortedCount}</span>
            </a>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default ResponsiveTabPhotoContainer;
